<template>
  <div id="app">
    <meta name="referrer" content="never">
    <keep-alive>
      <router-view />
    </keep-alive>

    <video-play ref="videoPlay" />
  </div>
</template>
<script>
  import autoRefresh from '@/assets/js/auto-update.js'
  import videoPlay from '@/components/video/video-play.vue'
  export default {
    components: {
      videoPlay
    },
    data() {
      return {}
    },
    beforeCreate() {
      document.body.className += ` theme_${this.$projectType}`;
      let link = document.createElement('link');
      link.rel = 'icon';
      switch (this.$projectType) {
        case 6:
          link.href = this.$config.url + '/manager/static/web-icon-zlgyl.ico'; // 替换为你的图标路径
          break;
        case 4:
          link.href = this.$config.url + '/manager/static/web-icon-yly.ico'; // 替换为你的图标路径
          break;
        default:
          link.href = this.$config.url + '/manager/static/web-icon.ico';
      }
      document.head.appendChild(link)
    },
    mounted() {
      autoRefresh(this)
      this.$bus.$on('videoPlay', this.$refs.videoPlay.play)
    },
  }
</script>

<style lang="scss">
  @import "./assets/css/main.css";
  @import "./assets/css/ys-common.scss";
  @import "./assets/css/color-dark.css";

  @import "./assets/css/tom.scss";
  @import "./assets/css/settingMini.scss";
  @import "./assets/css/element-ui.scss";

  /*深色主题*/
  .upload_demo .el-upload--text {
    width: 56px;
  }

  .tost_icon_box {
    display: inline-block;
    margin-left: 5px;
    color: #409EFF;
    font-size: 16px;
  }

  .tost_font {
    color: #409EFF;
    font-size: 12px;
    margin-left: 5px;
  }

  .el-upload--text {
    width: 85px;
    height: 36px;
    border: none;
  }

  .tips_box {
    line-height: 25px;
  }

  .tips_box .title {
    font-size: 20px;
  }

  .print-content {
    page-break-before: auto;
    page-break-after: always;
  }

  .print_box {
    position: fixed;
    z-index: -999;
    top: 0;
    display: inline-block;
    position: absolute;
    font-size: 13px;
  }

  .print_box thead tr {
    font-size: 13px;
    font-weight: normal;
  }

  .print_box table {
    display: table-header-group;
    border-collapse: collapse;
  }

  .print_box table thead th {
    height: 25px;
    font-size: 13px;
    /* width: 10px; */
    text-align: center;
    border: 1px solid black;
  }

  .border_tr {
    font-size: 13px;
    border: 1px solid black;
    height: 30px;
    text-align: center;
  }

  .border_tr td {
    padding: 0px;
    font-size: 13px;
    text-align: center;
    border: 1px solid black;
  }

  .print_title {
    width: 80%;
    margin-bottom: 10px;
  }

  .print_title span {
    display: inline-block;
  }

  .table_end2,
  .table_end {
    // width: 100%;
    height: 30px;
    font-size: 15px;
    border-left: 1px solid black;
    border-right: 1px solid black;
  }

  .table_end2 {
    width: calc(100% - 34px) !important;
  }

  .table_end,
  .table_end_sign {
    width: calc(100% - 34px) !important;
    font-size: 14px;
  }

  .table_end2 {
    font-size: 11px;
  }

  .table_end,
  .me_bottom {
    border-bottom: 1px solid black;
  }

  .cate_title_td {
    width: 100%;
    text-align: left;
    padding-left: 10px;
  }

  .table_end div,
  .table_end2 div,
  .table_end_sign div {
    display: inline-block;
    width: 300px;
    margin-left: 20px;
  }

  .code_img {
    width: 100px;
    height: 100px;
    float: right;
  }

  .show_style {
    z-index: -100;
  }

  .el-loading-spinner .el-loading-text {
    font-size: 32px !important;
  }

  .print_box .top-title {
    width: 100%;
    text-align: center;
    font-size: 28px;
    margin-bottom: 15px;
  }

  .print_box .top-desc {
    width: 100%;
    text-align: center;
    font-size: 18px;
    margin-bottom: 20px;
  }

  .print_box .top-line {
    width: 100%;
    display: flex;
    align-content: center;
    justify-content: space-between;
    margin-bottom: 10px;
  }

  .print_box .top-line .left {
    font-size: 18px;
  }

  .print_box .top-line .left span:last-child {
    font-size: 28px;
  }

  .print_box .top-line .right {
    font-size: 18px;
  }

  .absolute-right {
    position: absolute;
    top: 20px;
    right: 20px;
    display: flex;
    align-items: center;
    font-size: 14px;
  }

  .select_color {
    height: 20px;
    vertical-align: sub;

    .el-color-picker__trigger {
      width: 20px;
      height: 20px;
      padding: 0;
      border: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue